import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
export const SET_PLAYBACK_RATE = 'SET_PLAYBACK_RATE';
export const setPlaybackRate = _ref => {
  let {
    playbackRate
  } = _ref;
  return {
    playbackRate,
    type: SET_PLAYBACK_RATE
  };
};
export const SET_QUALITY = 'SET_QUALITY';
export const setQuality = _ref2 => {
  let {
    quality
  } = _ref2;
  return {
    quality,
    type: SET_QUALITY
  };
};
export const SET_SUBTITLE = 'SET_SUBTITLE';
export const setSubtitle = _ref3 => {
  let {
    selectedSubtitle
  } = _ref3;
  return {
    selectedSubtitle,
    type: SET_SUBTITLE
  };
};
export const TRANSCRIPT_FETCH_STARTED = 'TRANSCRIPT_FETCH_STARTED';
export const startTranscriptFetch = _ref4 => {
  let {
    exerciseId
  } = _ref4;
  return {
    exerciseId,
    type: TRANSCRIPT_FETCH_STARTED
  };
};
export const TRANSCRIPT_FETCH_ENDED = 'TRANSCRIPT_FETCH_ENDED';
export const setTranscriptData = _ref5 => {
  let {
    exerciseId,
    slides
  } = _ref5;
  return {
    exerciseId,
    slides,
    type: TRANSCRIPT_FETCH_ENDED
  };
};
export const getTranscript = _ref6 => {
  let {
    exerciseId,
    projectorKey,
    projectorUrl
  } = _ref6;
  return async (dispatch, getState) => {
    var _getState$transcript$;
    if (((_getState$transcript$ = getState().transcript[exerciseId]) === null || _getState$transcript$ === void 0 ? void 0 : _getState$transcript$.slides) == null) {
      dispatch(startTranscriptFetch({
        exerciseId
      }));
      const response = await fetch("".concat(projectorUrl, "/api/videos/").concat(projectorKey, "/transcript"), {
        credentials: 'include'
      });
      const transcript = await response.json();
      if (transcript == null) {
        return;
      }
      dispatch(setTranscriptData(_objectSpread({
        exerciseId
      }, transcript)));
    }
  };
};